/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './device-type.reducer';

export const DeviceTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const deviceTypeEntity = useAppSelector(state => state.deviceType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="deviceTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.deviceType.detail.title">DeviceType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.deviceType.id">Id</Translate>
            </span>
          </dt>
          <dd>{deviceTypeEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.deviceType.code">Code</Translate>
            </span>
          </dt>
          <dd>{deviceTypeEntity.code}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.deviceType.description">Description</Translate>
            </span>
          </dt>
          <dd>{deviceTypeEntity.description}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.deviceType.name">Name</Translate>
            </span>
          </dt>
          <dd>{deviceTypeEntity.name}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.deviceType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{deviceTypeEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.deviceType.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{deviceTypeEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.deviceType.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{deviceTypeEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.deviceType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{deviceTypeEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.deviceType.active">Active</Translate>
            </span>
          </dt>
          <dd>{deviceTypeEntity.active ? 'true' : 'false'}</dd>
        </dl>
        <Button tag={Link} to="/device-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/device-type/${deviceTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DeviceTypeDetail;
